module.exports = __webpack_public_path__ + "img/diagram_poor.9374976c.svg";